import React from 'react';
import './Card.css';

/**
 * Card – standard content container
 */
export default function Card({ title, subtitle, children, action, style, noPad }) {
  return (
    <div className="card" style={style}>
      {title && (
        <div className="card__header">
          <div>
            <div className="card__title">{title}</div>
            {subtitle && <div className="card__subtitle">{subtitle}</div>}
          </div>
          {action && <div className="card__action">{action}</div>}
        </div>
      )}
      <div className={`card__body ${noPad ? 'card__body--no-pad' : ''}`}>
        {children}
      </div>
    </div>
  );
}
